<template>
  <div class="row m-0">
    <transition name="fade">
      <add-contact v-if="isAdd" @close="closeContact" @save="saveContact"></add-contact>
    </transition>
    <div class="col-12 mb-3 p-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col p-0">
          <h4 class="mb-0">Add Trustee</h4>
        </div>
      </div>
    </div>
    <div class="col-12 white_bg p-4">
      <div class="row m-0 mb-3 align-items-center">
        <div class="col-12 p-0">
          <b>Select Contact</b>
        </div>
        <div class="col-12 p-0">
          <div class="row m-0 align-items-center">
            <div class="col p-0">
              <select class="form-control w-100" v-model="selectedContactID" @change="changeContact">
                <option disabled>--Select--</option>
                <option :value="key" v-for="(contact, key) in activeContacts" :key="key" :disabled="isAlreadyTrustee(key)">{{contact.firstname}} {{contact.lastname}}</option>
              </select>
            </div>
            <div class="col-auto pe-0 cursor text-end" @click="addContact">
              <div class="row m-0 align-items-center">
                <div class="col-auto p-0 medium mt-2">
                  <ios-add-circle-outline-icon />
                </div>
                <div class="col-auto p-0 ps-1 d-none d-md-inline-flex mt-1">
                  New Contact
                </div>
              </div>
            </div>
          </div>
        </div>
        <transition name="fade" mode="out-in">
          <div class="col-12 mt-3 p-0" v-if="isSelected" key="selected">
            <div class="row m-0 mb-2">
              <div class="col-12 p-0">
                <b>Contact Details</b>
              </div>
              <div class="col-12 p-0">
                Firstname: {{selectedContact.firstname}}
              </div>
              <div class="col-12 p-0">
                Lastname: {{selectedContact.lastname}}
              </div>
              <div class="col-12 p-0">
                Email: {{selectedContact.email}}
              </div>
              <div class="col-12 p-0">
                Relationship: {{selectedContact.relationship}}
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="row m-0 justify-content-end align-items-center mt-4">
        <!-- <div class="col-6 col-sm-4 pe-0">
          <button class="btn btn-secondary w-100" @click="close">Cancel</button>
        </div> -->
        <div class="col-6 col-sm-4 pe-0">
          <button class="btn btn-primary w-100" @click="save" :disabled="!selectedContactID">Add Trustee</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// @ is an alias to /src
export default {
  name: 'AddTrustee',
  components: {
    'add-contact': () => import('../components/AddContactPopup.vue')
  },
  data () {
    return {
      contact: {},
      selectedContactID: '',
      selectedContact: {},
      newContact: {},
      message: {},
      isAdd: false,
      isSelected: false
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'contacts', 'trustees']),
    activeContacts () {
      const obj = {}
      Object.entries(this.contacts).forEach(entry => {
        const [key, value] = entry
        if (!value.deleted) {
          obj[key] = value
        }
      })
      return obj
    }
  },
  methods: {
    ...mapActions(['inviteTrustee']),
    close () {
      this.$router.push('trustees')
    },
    addContact () {
      this.isAdd = true
    },
    closeContact () {
      this.isAdd = false
    },
    saveContact (val) {
      this.isAdd = false
      this.selectedContact = val
      this.selectedContactID = val.id
      this.isSelected = true
    },
    changeContact () {
      this.isSelected = true
      this.selectedContact = this.contacts[this.selectedContactID]
    },
    save () {
      this.inviteTrustee({ ...this.selectedContact, id: this.selectedContactID })
      this.$router.push('trustees')
    },
    isAlreadyTrustee (val) {
      return Object.keys(this.trustees).includes(val)
    }
  }
}
</script>
